"use client"

import type React from "react"
import { useEffect, useState } from "react"
import type { SetupData } from "../SetupFlow"
import "./SyncingProgress.css"

interface SyncingProgressProps {
  setupData: SetupData
  onComplete: () => void
}

const SyncingProgress: React.FC<SyncingProgressProps> = ({ setupData, onComplete }) => {
  const [progress, setProgress] = useState(0)

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          clearInterval(interval)
          return 100
        }
        return prev + 10
      })
    }, 500)

    return () => clearInterval(interval)
  }, [])

  const handleGoToHome = () => {
    onComplete()
  }

  return (
    <div className="syncing-progress">
      <div className="syncing-header">
        <h1>Syncing in Progress</h1>
      </div>

      <div className="syncing-animation">
        <div className="sync-container">
          <div className="platform-logo hubspot-logo">
            <img
              src={setupData.selectedConnector?.fromLogo || "https://cdn.worldvectorlogo.com/logos/hubspot-1.svg"}
              alt={setupData.selectedConnector?.from || "HubSpot"}
            />
          </div>

          <div className="sync-arrows">
            <div className="arrow-circle">
              <svg
                className="arrow-top"
                width="60"
                height="60"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M12 5l7 7-7 7" />
              </svg>
              <svg
                className="arrow-bottom"
                width="60"
                height="60"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M12 19l-7-7 7-7" />
              </svg>
            </div>
          </div>

          <div className="platform-logo salesforce-logo">
            <img
              src={setupData.selectedConnector?.toLogo || "https://cdn.worldvectorlogo.com/logos/salesforce-2.svg"}
              alt={setupData.selectedConnector?.to || "Salesforce"}
            />
          </div>
        </div>

        <div className="progress-indicator">
          <div className="progress-text">{progress < 100 ? `Syncing... ${progress}%` : "Sync Complete!"}</div>
          <div className="progress-bar">
            <div className="progress-fill" style={{ width: `${progress}%` }}></div>
          </div>
        </div>
      </div>

      <div className="syncing-actions">
        <button className="go-home-button" onClick={handleGoToHome} disabled={progress < 100}>
          {progress < 100 ? "Syncing..." : "Go to Home"}
        </button>
      </div>
    </div>
  )
}

export default SyncingProgress
